import Vue from 'vue';
import SignupApi from '../../api/SignupApi';
import LoginApi from '../../api/LoginApi';
import Segment from '../../Segment';
import phoneNumber from '../../utils/phoneNumber';

const inviteMemberFlowSteps = {
  enterDetails: 'enter-details',
  enterCode: 'enter-code',
  done: 'done',
};

const errorTypes = {
  memberAlreadyExists: 'MEMBER_ALREADY_EXISTS',
};

const state = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  enableMarketingEmails: '',
  currentFlowStep: inviteMemberFlowSteps.enterDetails,
  errors: {
    generateCode: '',
    createMember: '',
  },
};

const getters = {
  inviteMemberFlowSteps: () => inviteMemberFlowSteps,
  errorTypes: () => errorTypes,
};

const actions = {
  async generateCode({ dispatch, state, commit }) {
    if (phoneNumber.validatePhoneNumber(state.phoneNumber)) {
      try {
        await LoginApi.generateCode({ phoneNumber: state.phoneNumber });
      } catch (e) {
        dispatch('catchServerError', { e, functionName: 'generateCode' });
      }
    } else {
      commit('setError', { error: 'INVALID_PHONE_NUMBER', functionName: 'generateCode' });
      throw new Error('Invalid phone number');
    }
  },
  async createMember({ dispatch, state }) {
    try {
      await SignupApi.createMember({
        firstName: state.firstName,
        lastName: state.lastName,
        phoneNumber: state.phoneNumber,
        email: state.email,
        enableMarketingEmails: state.enableMarketingEmails,
      });
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'createMember' });
    }
  },
  catchServerError({ commit }, { e, functionName }) {
    if (e.response && e.response.status === 400) {
      commit('setError', { error: e.response.data, functionName });
    } else {
      commit('setError', { error: 'UNKNOWN_ERROR', functionName });
    }
    Segment.trackUserGot('MemberInviteError', { error: e });
    throw e;
  },
};

const mutations = {
  setCurrentFlowStep(state, currentFlowStep) {
    state.currentFlowStep = currentFlowStep;
  },
  setFirstName(state, firstName) {
    state.firstName = firstName;
  },
  setLastName(state, lastName) {
    state.lastName = lastName;
  },
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
  setError(state, { error, functionName }) {
    Vue.set(state.errors, functionName, error);
  },
  resetError(state, functionName) {
    Vue.set(state.errors, functionName, '');
  },
  setEmail(state, email) {
    state.email = email; // eslint-disable-line
  },
  setEnableMarketingEmails(state, enableMarketingEmails) {
    state.enableMarketingEmails = enableMarketingEmails; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
